module.exports = "/images/icon-failed.png?5853e3ce34b438cf3bf841c105566b10";